import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BaseTableComponent } from 'src/app/base/base-table/base-table.component';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.css', './../../base/base-table/base-table.component.css']
})

export class LeaderboardComponent extends BaseTableComponent implements OnInit {
  allStats: Observable<any[]>;
  allGoalieStats: Observable<any[]>;
  playerTableActive: boolean = true;
  positionSelect: string = 'Skaters';
  orderByField: string = 'GP';

  constructor(private firestore: AngularFirestore, private route: ActivatedRoute, private http: HttpClient) {
    super();
  }

  ngOnInit() {
    this.getData();
  }

  ngOnChanges() {
    this.getData();
  }

  getData() {
    this.allStats = this.firestore.collection('career_stats', ref => ref.orderBy(this.orderByField, 'desc')).valueChanges();
    this.allGoalieStats = this.firestore.collection('career_statsG', ref => ref.orderBy(this.orderByField, 'desc')).valueChanges();
  }

  updateTableView() {
    this.orderByField = 'GP';
    if(this.positionSelect == 'Goalies') {
      this.playerTableActive = false;
    }
    else {
      this.playerTableActive = true;
      switch(this.positionSelect) {
        case 'Skaters':
          this.allStats = this.firestore.collection('career_stats', ref => ref.orderBy(this.orderByField, 'desc')).valueChanges();
          break;
        case 'Forwards':
          this.allStats = this.firestore.collection('career_stats', ref => ref.where('Pos', '==', 'F').orderBy(this.orderByField, 'desc')).valueChanges();
          break;
        case 'Defensemen':
          this.allStats = this.firestore.collection('career_stats', ref => ref.where('Pos', '==', 'D').orderBy(this.orderByField, 'desc')).valueChanges();
          break;
      }
    }
  }
}
